function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "wordpress_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "wordpress_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wordpress_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "wordpress-logo-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "wordpress-logo-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#wordpress_mask_1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.0009765625 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 17.1783C1.76583 17.6959 3.63271 17.9815 5.56713 17.9815C7.8609 17.9815 10.0624 17.5846 12.1092 16.8643C12.0566 16.7797 12.0087 16.69 11.9695 16.5926L5.91153 0L0 17.1783Z",
  transform: "translate(19.432617 26.723633)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1059 25.7522L1.70705 0C0.614044 2.45051 0 5.1624 0 8.01866C0 15.8187 4.53289 22.5588 11.1059 25.7522Z",
  transform: "translate(5.294922 16.980469)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.1393 13.2744C27.1401 11.6514 26.2039 10.2774 26.2039 8.65385C26.2039 6.84265 27.5773 5.15673 29.5128 5.15673C29.6004 5.15673 29.6829 5.16756 29.7685 5.17168C26.2637 1.96123 21.5936 0 16.4632 0C9.57826 0 3.52186 3.53166 0 8.88173C0.461951 8.89565 0.896576 8.90544 1.26779 8.90544C3.32904 8.90544 6.5199 8.65539 6.5199 8.65539C7.58301 8.59146 7.70674 10.1521 6.64622 10.2774C6.64622 10.2774 5.57847 10.4027 4.39111 10.4656L11.5653 31.8086L15.877 18.8755L12.8062 10.465C11.7452 10.4021 10.7404 10.2769 10.7404 10.2769C9.67932 10.215 9.80305 8.59198 10.8646 8.65488C10.8646 8.65488 14.1194 8.90493 16.0543 8.90493C18.1151 8.90493 21.307 8.65488 21.307 8.65488C22.3701 8.59198 22.4943 10.1516 21.4323 10.2769C21.4323 10.2769 20.3635 10.4021 19.1772 10.465L26.2987 31.6462L28.2641 25.0789C29.1153 22.3536 29.7628 20.3954 29.7628 18.709C29.7628 16.274 28.8889 14.5881 28.1393 13.2744Z",
  transform: "translate(8.537109 5.2958984)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.51701 2.02619C7.51701 4.02557 7.14426 6.27346 6.01928 9.08383L0 26.4848C5.85739 23.0687 9.79893 16.722 9.79893 9.45401C9.79944 6.02753 8.92349 2.80625 7.384 0C7.46855 0.626933 7.51701 1.30181 7.51701 2.02619Z",
  transform: "translate(34.904297 15.545898)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 25C0 38.807 11.1925 50 24.9995 50C38.8065 50 49.999 38.807 49.999 25C49.999 11.193 38.8065 0 24.9995 0C11.1925 0 0 11.193 0 25ZM3.08517 24.999C3.08517 12.915 12.915 3.08466 25.0005 3.08466C37.0839 3.08466 46.9138 12.9155 46.9138 24.999C46.9143 37.0839 37.0834 46.9153 25.0005 46.9153C12.9156 46.9153 3.08517 37.085 3.08517 24.999Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})))));

var SvgWordpress = function SvgWordpress(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordpress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wordpress.ba22e79d.svg";
export { ForwardRef as ReactComponent };